import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import './App.css';
import './suggestions.css';
import translations from './translations.js';
import engineData from './engineData.js';
import logo from './assets/fuso-logo.svg';
import fusotransparent from './assets/fuso-transparent.svg';
import sendIcon from './assets/sendBtnHR.svg';
import chevronRight from './assets/chevron-right.svg';
import chevronLeft from './assets/chevron-left.svg';
import Markdown from 'markdown-to-jsx';
import FeedbackLink from "./feedbackButton/feedbackButton";
import ProfilePhoto from "./profilePhoto/profilePhoto.js";
// import AdminButton from "./admin/AdminButton.js"; // Admin button commented out
import userImage from './assets/user.png'
import LanguageDropDown from "./languageDropDown/dropDown.js";
import ModelDropDown from "./modelDropDown/modelDropDown.js";
import YearDropDown from "./modelDropDown/yearDropDown.js";
import ResponseModeToggle from "./responseMode/ResponseModeToggle.js";
import ImageModal from './imageModal/imageModal.js';
import { Tooltip } from '@chakra-ui/react';
import { ChakraProvider } from '@chakra-ui/react';
import { SkeletonText } from '@chakra-ui/react'
import UserHistory from "./userHistory/userHistory.js";
import { useToast } from '@chakra-ui/react'
import { Modal, ModalOverlay, ModalContent, ModalFooter, ModalBody, ModalHeader, ModalCloseButton, useDisclosure, Button, Textarea } from '@chakra-ui/react'
import Dictaphone from "./speechRecognition/speechRecognition.js";
import NewChat from "./assets/newChatHR.svg";
import toggleBtn from "./assets/toggleBtn.svg";
import botImgDTC from "./assets/mainChatImg.svg";
import redVector from "./assets/redVector.svg";
import starRating from "./assets/starRating.svg";
import StarRating from "./starRating/starRating";
import ProductTour from "./productTour/ProductTour";
import { handleSessionExpired } from "./utils/sessionExpiry";

const SERVER_URL = process.env.REACT_APP_API_BASE_URL
  ? `${process.env.REACT_APP_API_BASE_URL}/`
  : (process.env.NODE_ENV === 'development' ? 'http://localhost:5000/' : '/api/');
const CHAT_SERVER_URL = SERVER_URL + 'chat';
const HISTORY_SERVER_URL = SERVER_URL + 'history';
const FEEDBACK_SERVER_URL = SERVER_URL + 'feedback';
const SPEECH_SERVER_URL = SERVER_URL + 'speech';
const VEHICLE_DATA_URL = SERVER_URL + 'vehicle-data';
const MAX_QUESTION_LENGTH = 2000;

// Helper function to detect iPad and mobile devices
const isMobileOrTablet = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  // Check for iPad (including new iPads that identify as Mac)
  const isIPadDevice = /iPad/.test(userAgent) ||
    (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
  // Check for mobile devices
  const isMobile = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  // Check screen width for additional mobile detection
  const isSmallScreen = window.innerWidth <= 640;

  return isIPadDevice || isMobile || isSmallScreen;
};

const GUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

// Clear stale UUID or @tbdir.net values left in localStorage from old sessions
const storedUserinfo = localStorage.getItem('userinfo');
if (storedUserinfo && (GUID_RE.test(storedUserinfo) || storedUserinfo.includes('@tbdir.net'))) {
  localStorage.removeItem('userinfo');
}

function App() {
  const OverlayTwo = () => (
    <ModalOverlay
      bg='blackAlpha.300'
      backdropFilter='blur(10px) hue-rotate(90deg)'
    />
  )

  const [messages, setMessages] = useState([]);
  const [question, setQuestion] = useState('');
  const [engineFilter, setEngineFilter] = useState('');
  const [selectedYear, setSelectedYear] = useState('');
  const [modelFilter, setModelFilter] = useState('');
  const [selectedModel, setSelectedModel] = useState('');  // Model dropdown state
  const [isModelAlertOpen, setIsModelAlertOpen] = useState(false);
  const [isYearAlertOpen, setIsYearAlertOpen] = useState(false);
  const [langOpt, setLangOpt] = useState(sessionStorage.getItem('langOpt') || 'Japanese');
  const [response, setResponse] = useState('');
  const [solutions, setSolutions] = useState({});
  const [transcript, setTranscript] = useState('');
  const [selectedCase, setSelectedCase] = useState('');
  const [showActions, setShowActions] = useState(false);
  const [isAwaitingResponse, setIsAwaitingResponse] = useState(false);
  const [isLoadingConversation, setIsLoadingConversation] = useState(false); // Separate loader for history conversation fetch
  const [sidebarVisible, setSidebarVisible] = useState(!isMobileOrTablet());
  const [engineModels, setEngineModels] = useState([]);
  const [models, setModels] = useState([]);
  const [yearsByModel, setYearsByModel] = useState({});  // Available manual years per model (from backend)
  const [accessToken, setAccessToken] = useState(null);
  const [profileImage, setProfileImage] = useState(null);
  const [isBotLooking, setIsBotLooking] = useState(false);
  const [hasCopied, setHasCopied] = useState(false);
  const [selectedChat, setSelectedChat] = useState(null);
  const [historyMessages, setHistoryMessages] = useState([]);
  const messageSection = useRef(null);
  const toast = useToast({ position: 'top-right' })
  const [childFunc, setChildFunc] = useState(null);
  const [removeChatFunc, setRemoveChatFunc] = useState([]);
  const [audioSrc, setAudioSrc] = useState(null);
  const audioRef = useRef(null);
  const [speechPlay, setSpeechPlay] = useState(false);
  const [speechSpinner, setSpeechSpinner] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure()
  const { isOpen: isFeedbackOpen, onOpen: onFeedbackOpen, onClose: onFeedbackClose } = useDisclosure()
  const [overlay, setOverlay] = React.useState(<OverlayTwo />)
  const [feedback, setFeedback] = useState('');
  const [feedbackText, setFeedbackText] = useState('');
  const [feedbackRating, setFeedbackRating] = useState(5);
  const [feedbackSubmitted, setFeedbackSubmitted] = useState(false);
  const [voteFeedbackSubmitted, setVoteFeedbackSubmitted] = useState(false);
  const [responseVote, setResponseVote] = useState('');
  const [conversationId, setConversationId] = useState('');
  const [selectedImage, setSelectedImage] = useState(null);
  const [hideZoomControls, setHideZoomControls] = useState(false);
  const { isOpen: isImageModalOpen, onOpen: openImageModal, onClose: closeImageModal } = useDisclosure();

  // New state for suggestions (contextual awareness feature)
  const [suggestions, setSuggestions] = useState([]);

  // New state for tracking feedback status for each message
  const [messageFeedback, setMessageFeedback] = useState({});

  // State to track the current message_id from the latest chat response
  const [currentMessageId, setCurrentMessageId] = useState('');

  // Ref to store the AbortController for cancelling pending requests
  const abortControllerRef = useRef(null);

  const [responseMode, setResponseMode] = useState('deep');
  const [thinkingStatus, setThinkingStatus] = useState('');
  const [isFetchingManuals, setIsFetchingManuals] = useState(false);
  const [isFetchingSuggestions, setIsFetchingSuggestions] = useState(false);

  useEffect(() => {
    sessionStorage.setItem('langOpt', langOpt);
  }, [langOpt]);

  // Fetch available manual years per model from backend (populates Year dropdown)
  useEffect(() => {
    fetch(VEHICLE_DATA_URL)
      .then((res) => res.json())
      .then((data) => setYearsByModel(data?.years_by_model || {}))
      .catch((err) => console.error('Failed to load vehicle year data:', err));
  }, []);

  // Auto-select the year when the chosen model has only one available year
  useEffect(() => {
    if (!selectedModel) return;
    const years = yearsByModel[selectedModel] || [];
    if (years.length === 1 && !selectedYear) {
      setSelectedYear(years[0]);
    }
  }, [selectedModel, yearsByModel]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    sessionStorage.getItem('profileImage') ? setProfileImage(sessionStorage.getItem('profileImage')) : setProfileImage(userImage);
  }, [profileImage]);

  useEffect(() => {
    setMessages(historyMessages)
  }, [historyMessages]);

  useEffect(() => {

  }, [messages]);



  const openHistory = (message) => {
    setSolutions({});
    setSpeechPlay(false);
    setSelectedCase(null);

    // Messages are now in ASC order (oldest first) from backend - no reversal needed
    const orderedMessages = message;

    const newMessages = orderedMessages.map((entry, index) => {
      let assistantResponseContent;
      let assistantImages = [];
      let assistantManuals = [];
      try {
        let assistantResponseObject;

        if (typeof entry.AssistantResponse === 'string') {
          // Try to parse as JSON first
          try {
            assistantResponseObject = JSON.parse(entry.AssistantResponse);
          } catch (jsonError) {
            // If JSON parse fails, treat as plain text (old format)
            assistantResponseObject = { response: entry.AssistantResponse };
          }
        } else {
          assistantResponseObject = entry.AssistantResponse;
        }

        assistantResponseContent = assistantResponseObject.response || assistantResponseObject.text || entry.AssistantResponse;

        // Set images if available
        if (entry.images && entry.images.length > 0) {
          assistantImages = entry.images;
        }
        if (entry.manuals && entry.manuals.length > 0) {
          assistantManuals = entry.manuals;
        }
      } catch (error) {
        console.error('Error parsing AssistantResponse:', error, entry.AssistantResponse);
        assistantResponseContent = String(entry.AssistantResponse || "Error parsing response");
      }

      // Only show suggestions on the LAST message in conversation
      const isLastMessage = index === orderedMessages.length - 1;

      return [
        { role: 'user', content: entry.UserResponse },
        {
          role: 'assistant',
          content: assistantResponseContent,
          images: assistantImages,
          manuals: assistantManuals,
          suggestions: entry.suggestions
        },
      ];
    }).flat();

    setHistoryMessages(newMessages);

    // Use the last message for response and solutions (most recent - last in ASC order)
    const lastMessage = orderedMessages[orderedMessages.length - 1];

    // Parse AssistantResponse safely
    let lastAssistantResponse;
    try {
      lastAssistantResponse = typeof lastMessage.AssistantResponse === 'string'
        ? JSON.parse(lastMessage.AssistantResponse)
        : lastMessage.AssistantResponse;
    } catch (e) {
      // Old format: plain text
      lastAssistantResponse = { response: lastMessage.AssistantResponse };
    }

    setResponse(lastAssistantResponse.response || lastMessage.AssistantResponse);

    if (lastAssistantResponse?.solutions) {
      setSolutions(lastAssistantResponse.solutions);
    }

    // FIX: Set the currentMessageId from the selected historical message
    if (lastMessage.message_id) {
      setCurrentMessageId(lastMessage.message_id);
    }

    // Restore suggestions if available
    if (lastMessage.suggestions && Array.isArray(lastMessage.suggestions)) {
      setSuggestions(lastMessage.suggestions);
    } else {
      setSuggestions([]);
    }

    setTimeout(() => {
      messageSection.current.scrollTo({
        top: messageSection.current.scrollHeight,
        behavior: 'smooth'
      })
    }, 500);

    setEngineFilter(lastMessage.Engine);
    setModelFilter(lastMessage.Model);
    setSelectedChat(orderedMessages[0].ChatId);
    setTranscript(`**Assistant**: ${lastAssistantResponse.response || lastMessage.AssistantResponse}`);
    setShowActions(true);
    setSelectedCase('');
  }



  const handleBlur = () => {
    setIsBotLooking(false);
  };

  const handleNewChat = () => {
    // Cancel any pending API requests
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
      abortControllerRef.current = null;
    }

    const newMessages = [];
    resetSectedChat();
    setSelectedCase('');
    setSelectedChat(null);
    setModelFilter('');
    setEngineFilter('');
    setSelectedModel('');  // Reset model selection
    setSelectedYear('');   // Reset year selection
    setMessages(newMessages)
    setSpeechPlay(false);
    setConversationId('');
    // Reset message feedback state for new chat
    setMessageFeedback({});
    // Reset current message ID
    setCurrentMessageId('');
    // Reset awaiting response state
    setIsAwaitingResponse(false);
    // Reset suggestions
    setSuggestions([]);
  }

  const handleCopy = () => {
    const lastAssistantMessage = messages.filter(m => m.role === 'assistant').pop();
    const textToCopy = lastAssistantMessage ? `${lastAssistantMessage.content} ${selectedCase ? '\n\n\n' + solutions[selectedCase] : ''}` : '';
    navigator.clipboard.writeText(textToCopy);
    setHasCopied(true);
    setTimeout(() => setHasCopied(false), 2000);
  };

  const handleChange = (e) => {
    if (e.target.value.length > 0) {
      setIsBotLooking(true);
    } else {
      setIsBotLooking(false);
    }
    setQuestion(e.target.value)
  };

  const translate = (text) => {
    if (!text || !translations[text]) return text;
    switch (langOpt) {
      case 'Japanese':
        return translations[text].translationJp || text;
      case 'Indonesian':
        return translations[text].translationIn || text;
      case 'Nepali':
        return translations[text].translationNp || text;
      case 'Sinhala':
        return translations[text].translationSl || text;
      case 'Vietnamese':
        return translations[text].translationVn || text;
      case 'Filipino':
        return translations[text].translationPh || text;
      case 'Bengali':
        return translations[text].translationBd || text;
      case 'English':
      default:
        return translations[text].translationEng || text;
    }
  };

  const cleanTextForSpeech = (text) => {
    return text
      .replace(/[#*・【】]/g, '')
      .replace(/\[.*?\]/g, '')
      .replace(/\n{2,}/g, '\n')
      .replace(/\s{2,}/g, ' ')
      .trim();
  };

  const formatMessageContent = (text) => {
    if (!text) return text;
    // Replace literal \n strings with actual newline characters
    // Handle both single and double escaped newlines
    return text
      .replace(/\\\\n/g, '\n')
      .replace(/\\n/g, '\n')
      // Remove markdown image links like ![](url) or ![alt](url)
      .replace(/!\[.*?\]\(.*?\)/g, '');
  };

  const fetchAudio = async () => {
    try {
      setSpeechSpinner(true);
      const cleanedText = cleanTextForSpeech(`${response} ${selectedCase ? '\n\n\n' + solutions[selectedCase] : ''}`);
      let body = {
        "text": cleanedText,
        "language": langOpt
      }
      const speechResponse = await axios.post(SPEECH_SERVER_URL, body, { responseType: 'blob' });
      if (speechResponse.status === 200) {
        const blob = new Blob([speechResponse.data], { type: 'audio/wav' });
        const audioURL = URL.createObjectURL(blob);
        setAudioSrc(audioURL);
        if (audioRef.current) {
          setSpeechSpinner(false);
          setSpeechPlay(true)
          audioRef.current.src = audioURL;
          audioRef.current.load();
          audioRef.current.play();
          audioRef.current.onended = handleAudioEnd;
        }
      } else {
        console.error("Error fetching audio:", speechResponse.statusText);
      }
    } catch (error) {
      console.error("Error fetching audio:", error);
    }
  };

  const handleAudioEnd = () => {
    setSpeechPlay(false)
  };

  const handlePause = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      setSpeechPlay(false)
    }
  };

  const triggerChildFunction = (historyResponse) => {
    if (childFunc) {
      childFunc(historyResponse);
    }
  };

  const resetSectedChat = () => {
    if (removeChatFunc) {
      const data = ""
      removeChatFunc(data);
    }
  };

  const handleUserHistory = async (userResponse, assistantResonse) => {
    // History is now stored on backend automatically during /chat endpoint
    // No need to make separate POST call to /history

    // Update conversation_id if returned from backend
    const currentConversationId = assistantResonse.conversation_id || conversationId;

    if (selectedChat === null && currentConversationId) {
      setSelectedChat(currentConversationId);
    }

    // Trigger UI update for history sidebar
    if (assistantResonse?.images && assistantResonse.images.length) {
      const entity = {
        ChatId: currentConversationId,
        UserResponse: userResponse,
        AssistantResponse: { response: assistantResonse.response },
        images: assistantResonse.images,
        manuals: assistantResonse.manuals,
        message_id: assistantResonse.message_id,
        Timestamp: new Date().toISOString()
      };
      triggerChildFunction(entity);
    } else {
      const entity = {
        ChatId: currentConversationId,
        UserResponse: userResponse,
        AssistantResponse: assistantResonse,
        message_id: assistantResonse.message_id,
        Timestamp: new Date().toISOString()
      };
      triggerChildFunction(entity);
    }
  }

  const handleSendMessage = async (messageOverride = null) => {
    if (isAwaitingResponse) return;

    if (!selectedModel) {
      setIsModelAlertOpen(true);
      return;
    }

    if (!selectedYear) {
      setIsYearAlertOpen(true);
      return;
    }

    const currentQuestion = typeof messageOverride === 'string' ? messageOverride : question;

    if (!currentQuestion.trim()) return;

    if (currentQuestion.length > MAX_QUESTION_LENGTH) {
      toast({
        title: translate("Message too long"),
        description: translate("Questions must be 2000 characters or fewer."),
        status: 'error',
        duration: 5000,
        isClosable: true
      });
      return;
    }

    setIsAwaitingResponse(true);
    if (!messageOverride) setQuestion('');

    setMessages(prevMessages => [
      ...prevMessages,
      { role: 'user', content: currentQuestion },
      { role: 'assistant', content: '', streaming: true }
    ]);
    setShowActions(true);

    setTimeout(() => {
      messageSection.current.scrollTo({ top: messageSection.current.scrollHeight, behavior: 'smooth' });
    }, 200);

    const abortController = new AbortController();
    abortControllerRef.current = abortController;

    const body = {
      question: currentQuestion,
      lang_opt: langOpt,
      user_email: localStorage.getItem('userinfo') || "sumanth",
      model: selectedModel,
      year: selectedYear,
      response_mode: responseMode,
      ...(conversationId !== '' && { conversation_id: conversationId })
    };

    try {
      const res = await fetch(CHAT_SERVER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        signal: abortController.signal
      });

      // Session/token expired mid-chat → show the popup and log out.
      if (res.status === 401 || res.status === 403) {
        handleSessionExpired();
        return;
      }

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buffer = '';

      while (true) {
        const { done, value } = await reader.read();
        if (done) break;

        buffer += decoder.decode(value, { stream: true });
        const lines = buffer.split('\n');
        buffer = lines.pop();

        for (const line of lines) {
          if (!line.startsWith('data: ')) continue;
          const jsonStr = line.slice(6).trim();
          if (!jsonStr) continue;

          let event;
          try { event = JSON.parse(jsonStr); } catch { continue; }

          if (event.type === 'init') {
            if (event.conversation_id) setConversationId(event.conversation_id);
            if (event.message_id) setCurrentMessageId(event.message_id);
          } else if (event.type === 'status') {
            const statusText = event.text || '';
            if (statusText === 'generating_suggestions') {
              setIsFetchingSuggestions(true);
            } else if (statusText === 'Fetching manual pages...') {
              setIsFetchingManuals(true);
              setThinkingStatus('');
            } else {
              setThinkingStatus(statusText);
            }
          } else if (event.type === 'token') {
            setMessages(prev => {
              const updated = [...prev];
              const idx = updated.findLastIndex(m => m.role === 'assistant' && m.streaming);
              if (idx !== -1) {
                updated[idx] = { ...updated[idx], content: updated[idx].content + (event.text || '') };
              }
              return updated;
            });
            setTimeout(() => {
              messageSection.current?.scrollTo({ top: messageSection.current.scrollHeight, behavior: 'smooth' });
            }, 50);
          } else if (event.type === 'done') {
            const fullResponse = event.response || '';
            const manuals = event.manuals || [];
            const suggestions = event.suggestions || [];
            const messageId = event.message_id || '';

            setResponse(fullResponse);
            setMessages(prev => {
              const updated = [...prev];
              const idx = updated.findLastIndex(m => m.role === 'assistant' && m.streaming);
              if (idx !== -1) {
                updated[idx] = { ...updated[idx], content: fullResponse, streaming: false, manuals, suggestions };
              }
              return updated;
            });

            if (event.solutions) setSolutions(event.solutions); else setSolutions({});
            if (messageId) setCurrentMessageId(messageId);
            if (suggestions.length > 0) setSuggestions(suggestions); else setSuggestions([]);
            setThinkingStatus('');
            setIsFetchingManuals(false);
            setIsFetchingSuggestions(false);
            setTranscript(`**Assistant**: ${fullResponse}\n\n`);
            setShowActions(true);
            setSelectedCase('');
            handleUserHistory(currentQuestion, { ...event, response: fullResponse });
          } else if (event.type === 'error') {
            // Remove the streaming placeholder message
            setMessages(prev => prev.filter(m => !(m.role === 'assistant' && m.streaming)));
            toast({
              title: translate("Error"),
              description: event.text || translate("Unable to send your message. Please try again."),
              status: 'error',
              duration: 5000,
              isClosable: true
            });
          }
        }
      }
    } catch (error) {
      if (error.name === 'AbortError' || error.name === 'CanceledError') return;
      console.error('Error sending message:', error);
      setMessages(prev => prev.filter(m => !(m.role === 'assistant' && m.streaming)));
      toast({
        title: translate("Error"),
        description: translate("Unable to send your message. Please try again."),
        status: 'error',
        duration: 5000,
        isClosable: true
      });
    } finally {
      if (!abortControllerRef.current?.signal.aborted) {
        // Clean up any leftover streaming placeholders
        setMessages(prev => prev.map(m =>
          m.streaming ? { ...m, streaming: false } : m
        ));
        setIsAwaitingResponse(false);
        setThinkingStatus('');
        setIsFetchingManuals(false);
        setIsFetchingSuggestions(false);
        setTimeout(() => {
          messageSection.current?.scrollTo({ top: messageSection.current.scrollHeight, behavior: 'smooth' });
        }, 200);
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      handleSendMessage();
    }
  };

  const handleFeedbackChange = (event) => {
    setFeedback(event.target.value);
  };

  const handleFeedbackTextChange = (event) => {
    setFeedbackText(event.target.value);
  };

  const handleSidebarFeedbackSubmit = async () => {
    if (!feedbackRating) return;

    try {
      let feedback_body = {
        UserEmail: localStorage.getItem('userinfo'),
        Rating: feedbackRating,
        Feedback: feedbackText,
      };

      const response = await axios.post(SERVER_URL + 'submit-feedback', feedback_body);

      if (response.data.valid) {
        setFeedbackSubmitted(true);
        setTimeout(() => {
          setFeedbackSubmitted(false);
          setFeedbackText('');
          setFeedbackRating(5);
          onFeedbackClose();
        }, 2000);
      } else {
        toast({
          title: translate('Submission failed'),
          description: translate('Something went wrong. Please try again.'),
          status: 'error',
          duration: 2000,
          isClosable: true,
        });
      }
    } catch (error) {
      toast({
        title: translate('Submission failed'),
        description: translate('Something went wrong. Please try again.'),
        status: 'error',
        duration: 2000,
        isClosable: true,
      });
    }
  };

  const handleDownVote = async (event) => {
    try {
      if (responseVote === "down") {
        if (feedback === "" || feedback === " ") {
          return
        }
      }
      let body = {
        vote: responseVote,
        transcript: transcript,
        feedback: feedback,
        userEmail: localStorage.getItem('userinfo'),
        message_id: currentMessageId
      }
      await axios.post(FEEDBACK_SERVER_URL, body);

      setVoteFeedbackSubmitted(true);
      setTimeout(() => {
        setVoteFeedbackSubmitted(false);
        setFeedback('');
        onClose();
      }, 2000);

    } catch (error) {
      setFeedback('');
      onClose();
      console.error('Error sending feedback:', error);
    }
  }

  const handleFeedback = async (vote) => {
    try {
      await axios.post(FEEDBACK_SERVER_URL, {
        vote,
        transcript,
        feedback: "",
        userEmail: localStorage.getItem('userinfo'),
        message_id: currentMessageId
      });

      toast({
        title: translate('Feedback created'),
        description: translate("Feedback Shared Successfully"),
        status: 'success',
        duration: 1000,
        isClosable: true,
      })
    } catch (error) {
      console.error('Error sending feedback:', error);
    }
  };

  const handleDownload = () => {
    const element = document.createElement("a");
    const file = new Blob([transcript], { type: 'text/markdown' });
    element.href = URL.createObjectURL(file);
    element.download = `chat-${new Date().toISOString()}.txt`;
    document.body.appendChild(element);
    element.click();
  };

  const selectCase = (caseId) => {
    setSelectedCase(caseId);
  }

  const toggleSidebar = () => {
    setSidebarVisible(!sidebarVisible);
  }

  // Sidebar resizing functionality
  const [sidebarWidth, setSidebarWidth] = useState(250);
  const [isResizing, setIsResizing] = useState(false);
  const sidebarRef = useRef(0);
  const resizerOffset = useRef(0);
  const minSidebarWidth = 200;
  const maxSidebarWidth = 1000;

  const handleMouseDown = (e) => {
    setIsResizing(true);
    resizerOffset.current = e.clientX - sidebarRef.current.getBoundingClientRect().right;
    e.preventDefault();
  };

  const handleMouseMove = (e) => {
    if (isResizing) {
      const newWidth = e.clientX - sidebarRef.current.getBoundingClientRect().left - resizerOffset.current - 30;
      if (newWidth >= minSidebarWidth && newWidth <= maxSidebarWidth) {
        setSidebarWidth(newWidth);
      }
    }
  };

  const handleMouseUp = () => {
    if (isResizing) {
      setIsResizing(false);
    }
  };

  useEffect(() => {
    if (isResizing) {
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    } else {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    }
    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [isResizing]);

  return (
    <>
      <ChakraProvider resetCSS={false}>
        <Modal isCentered isOpen={isOpen} onClose={onClose}>
          {overlay}
          <ModalContent className="custom-modal-content">
            <ModalCloseButton />
            {!voteFeedbackSubmitted ? (
              <>
                <ModalBody>
                  <h2 className="feedback-title">{translate("Help us shape a better experience by sharing your feedback!")}</h2>
                  <Textarea className='feedInputBox' placeholder={translate("Enter your feedback")} onChange={handleFeedbackChange}></Textarea>
                </ModalBody>
                <ModalFooter>
                  <Button className='closeBtnDTC' onClick={onClose} mr={3} >{translate('Close')}</Button>
                  <Button
                    className={feedback.trim() ? 'submitBtnDTC active' : 'submitBtnDTC'}
                    colorScheme='blue'
                    onClick={() => handleDownVote()}
                    isDisabled={!feedback.trim()}
                  >
                    {translate('Submit')}
                  </Button>
                </ModalFooter>
              </>
            ) : (
              <ModalBody className="feedback-success">
                <div className="success-icon">
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <circle cx="32" cy="32" r="32" fill="#00AA44" />
                    <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h2 className="success-title">{translate('Thank You!')}</h2>
                <p className="success-message">{translate('Your feedback was successfully submitted.')}</p>
              </ModalBody>
            )}
          </ModalContent>
        </Modal>
        <Modal isCentered isOpen={isFeedbackOpen} onClose={onFeedbackClose}>
          {overlay}
          <ModalContent className="custom-modal-content">
            <ModalCloseButton />
            {!feedbackSubmitted ? (
              <>
                <ModalBody>
                  <h2 className="feedback-title">{translate("Help us shape a better experience by sharing your feedback!")}</h2>
                  <StarRating rating={feedbackRating} setRating={setFeedbackRating} />
                  <Textarea className='feedInputBox' placeholder={translate("Enter your feedback")} onChange={handleFeedbackTextChange} value={feedbackText}></Textarea>
                </ModalBody>
                <ModalFooter>
                  <Button className='closeBtnDTC' onClick={onFeedbackClose} mr={3}>{translate('Close')}</Button>
                  <Button
                    className={feedbackText.trim() ? 'submitBtnDTC active' : 'submitBtnDTC'}
                    colorScheme='blue'
                    onClick={handleSidebarFeedbackSubmit}
                    isDisabled={!feedbackText.trim()}
                  >
                    {translate('Submit')}
                  </Button>
                </ModalFooter>
              </>
            ) : (
              <ModalBody className="feedback-success">
                <div className="success-icon">
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
                    <circle cx="32" cy="32" r="32" fill="#00AA44" />
                    <path d="M20 32L28 40L44 24" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <h2 className="success-title">{translate('Thank You!')}</h2>
                <p className="success-message">{translate('Your feedback was successfully submitted.')}</p>
              </ModalBody>
            )}
          </ModalContent>
        </Modal>
      </ChakraProvider>
      <div className="App scroll-div">
        <header>
          {!sidebarVisible && (
            <button className="mobile-menu-btn" onClick={toggleSidebar}>
              <img src={chevronRight} alt="Open Menu" />
            </button>
          )}
          <img src={logo} alt="Fuso Logo" className="fuso-logo" />
          <div className="header-toolbar">
            {/* <AdminButton translate={translate} /> */}
            <LanguageDropDown setLanguage={setLangOpt} translate={translate}></LanguageDropDown>
            <ProfilePhoto translate={translate} />
          </div>
        </header>
        <div className={`content ${langOpt === "English" ? 'jakartaFont' : 'japaneseFont'}`}>
          {sidebarVisible && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}
          <aside className={`sidebar ${sidebarVisible ? '' : 'sidebar-collapsed'}`}
            ref={sidebarRef}
            style={{ width: sidebarVisible ? `${sidebarWidth}px` : '60px' }}>
            {sidebarVisible ? (
              <>
                <div className="sidebar-tools">
                  <div className="chat-bot" onClick={toggleSidebar}>
                    <img className="bot-image" src="./bot1.svg" alt="botImage"></img>
                    <h1>DTC Chatbot</h1>
                  </div>
                  <div className="sidebar-tool-button">
                    <button className='start-new-btn' style={{ fontSize: langOpt === 'Japanese' ? '14px' : '14px', fontWeight: '400' }}
                      onClick={handleNewChat}>
                      <img src={NewChat} alt="newChatIcon" ></img>
                      {translate("New chat")}
                    </button>
                    <FeedbackLink translate={translate} langOpt={langOpt} />
                  </div>
                  <UserHistory
                    openHistory={openHistory}
                    setChildFunc={setChildFunc}
                    setRemoveChatFunc={setRemoveChatFunc}
                    translate={translate}
                    handleNewChat={handleNewChat}
                    setConversationId={setConversationId}
                    toggleSidebar={toggleSidebar}
                    setIsLoadingConversation={setIsLoadingConversation}
                  />
                </div>
                <Tooltip label={translate("Close Sidebar")} className="tooltip">
                  <button className="toggle-sidebar" onClick={toggleSidebar}>
                    <img src={toggleBtn} alt="Collapse Sidebar" />
                  </button>
                </Tooltip>
              </>
            ) : (
              <div className="sidebar-collapsed-content">
                {/* <Tooltip label="DTC Chatbot" className="tooltip"> */}
                <div className="sidebar-icon">
                  <img src="./bot1.svg" alt="botImage" />
                </div>
                {/* </Tooltip> */}
                <Tooltip label={translate("New chat")} className="tooltip">
                  <button className="sidebar-icon-btn" onClick={handleNewChat}>
                    <img src={NewChat} alt="newChatIcon" />
                  </button>
                </Tooltip>
                <Tooltip label={translate("Submit Feedback")} className="tooltip">
                  <button className="sidebar-icon-btn" onClick={() => {
                    setOverlay(<OverlayTwo />);
                    onFeedbackOpen();
                  }}>
                    <img src="./feedback.svg" alt="feedbackIcon" />
                  </button>
                </Tooltip>
                <Tooltip label={translate("Open Sidebar")} className="tooltip">
                  <button className="toggle-sidebar-open" onClick={toggleSidebar}>
                    <img src={chevronRight} alt="Expand Sidebar" />
                  </button>
                </Tooltip>
              </div>
            )}
          </aside>
          {sidebarVisible && (
            <div
              className="resizer"
              onMouseDown={handleMouseDown}
              style={{ cursor: 'col-resize', width: '1px', height: '100%', backgroundColor: '#e2e8f0' }}
            ></div>
          )}
          <main className={`main ${sidebarVisible ? '' : 'full-width'}`}>
            <div className='main-div' ref={messageSection} id="testing">
              {messages.length === 0 && (
                <div className="welcome-screen">
                  <div className="welcome-content">
                    <img src={botImgDTC} alt="DTC Chatbot" className="welcome-bot-image" />
                    <h1 className="welcome-title">{translate("WelcomeDTC")}
                      <img src={redVector} alt="vector" />
                    </h1>

                    <p className="welcome-subtitle"> {translate("AI Subheading")} </p>
                  </div>
                </div>
              )}
              {showActions && <div className="chat-window">
                {messages.map((message, index) => (
                  <React.Fragment key={index}>
                    <div className={`message ${message.role}`}>
                      {message.role === 'assistant' && (
                        <>
                          {/* <img src={fusotransparent} alt="Assistant" /> */}
                          <div className="message-width">
                            {message.streaming && !message.content ? (
                              <div className="thinking-indicator">
                                <div className="thinking-dots">
                                  <span></span>
                                  <span></span>
                                  <span></span>
                                </div>
                                <span className="thinking-text">{thinkingStatus || translate('Thinking...')}</span>
                              </div>
                            ) : message.streaming ? (
                              <div className="streaming-text">
                                {formatMessageContent(message.content)}
                                <span className="streaming-cursor"></span>
                                {isFetchingManuals && (
                                  <div className="fetching-indicator">
                                    <div className="thinking-dots">
                                      <span></span><span></span><span></span>
                                    </div>
                                    <span className="thinking-text">{translate('Fetching manual pages...')}</span>
                                  </div>
                                )}
                              </div>
                            ) : (
                              <Markdown>{formatMessageContent(message.content)}</Markdown>
                            )}

                            {message.images && message.images.length > 0 && (
                              <div className='cases'>
                                {message.images.map((image, index) => (
                                  <div key={index} className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
                                    <img
                                      src={`data:image/png;base64,${image}`}
                                      alt={`Image ${index + 1}`}
                                      style={{
                                        width: 'auto',
                                        height: 'auto',
                                        maxWidth: 'none',
                                        maxHeight: 'none',
                                        margin: '5px',
                                        boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                        cursor: 'default',
                                        minHeight: '180px'
                                      }}
                                    />
                                  </div>
                                ))}
                              </div>
                            )}
                            {message.manuals && message.manuals.length > 0 && (
                              <div className='cases'>
                                {message.manuals.map((manual, index) => (
                                  <React.Fragment key={index}>
                                    {manual.base64_image &&
                                      <div className="image-container" style={{ position: 'relative', display: 'inline-block' }}>
                                        <img
                                          src={`data:image/jpeg;base64,${manual?.base64_image}`}
                                          alt={`Image ${index + 1}`}
                                          style={{
                                            width: 'auto',
                                            height: '200px',
                                            maxWidth: '100%',
                                            margin: '5px',
                                            boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
                                            cursor: 'pointer',
                                            minHeight: '180px'
                                          }}
                                          onClick={() => {
                                            setSelectedImage(manual.base64_image);
                                            setHideZoomControls(false); // Keep zoom controls for manual images
                                            openImageModal();
                                          }}
                                        />
                                        {/* Arrow overlay for new tab */}
                                        <div
                                          className="image-overlay-arrow"
                                          onClick={(e) => {
                                            e.stopPropagation(); // Prevent modal from opening

                                            // Convert base64 to blob and open in new tab
                                            const byteCharacters = atob(manual.base64_image);
                                            const byteNumbers = new Array(byteCharacters.length);
                                            for (let i = 0; i < byteCharacters.length; i++) {
                                              byteNumbers[i] = byteCharacters.charCodeAt(i);
                                            }
                                            const byteArray = new Uint8Array(byteNumbers);
                                            const blob = new Blob([byteArray], { type: 'image/jpeg' });
                                            const blobUrl = URL.createObjectURL(blob);

                                            window.open(blobUrl, '_blank');

                                            // Clean up the blob URL after a delay
                                            setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
                                          }}
                                          style={{
                                            position: 'absolute',
                                            top: '10px',
                                            right: '10px',
                                            background: 'rgba(0, 0, 0, 0.7)',
                                            borderRadius: '4px',
                                            padding: '6px',
                                            cursor: 'pointer',
                                            transition: 'all 0.2s ease',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            zIndex: 10
                                          }}
                                          onMouseEnter={(e) => {
                                            e.target.style.background = 'rgba(0, 0, 0, 0.9)';
                                            e.target.style.transform = 'scale(1.1)';
                                          }}
                                          onMouseLeave={(e) => {
                                            e.target.style.background = 'rgba(0, 0, 0, 0.7)';
                                            e.target.style.transform = 'scale(1)';
                                          }}
                                          title="Open in new tab"
                                        >
                                          {/* External link arrow icon */}
                                          <svg
                                            width="16"
                                            height="16"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="white"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            style={{ pointerEvents: 'none' }}
                                          >
                                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                                            <polyline points="15,3 21,3 21,9" />
                                            <line x1="10" y1="14" x2="21" y2="3" />
                                          </svg>
                                        </div>
                                      </div>
                                    }
                                  </React.Fragment>
                                ))}
                              </div>
                            )}
                            {/* Suggestions loading indicator */}
                            {isFetchingSuggestions && !message.streaming && !message.suggestions?.length && (
                              <div className="fetching-indicator" style={{ marginTop: '10px' }}>
                                <div className="thinking-dots">
                                  <span></span><span></span><span></span>
                                </div>
                                <span className="thinking-text">{translate('Loading suggestions...')}</span>
                              </div>
                            )}
                            {/* Suggestions inside message bubble */}
                            {message.suggestions && message.suggestions.length > 0 && (
                              <div className="suggestions-container" style={{ marginTop: '15px' }}>
                                <div className="suggestions-label" style={{ fontSize: '0.85em', color: '#666', marginBottom: '8px', fontWeight: '500' }}>
                                  {translate("Quick suggestions") || "Quick suggestions"}:
                                </div>
                                <div className="suggestions-buttons" style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                                  {message.suggestions.map((suggestion, idx) => (
                                    <button
                                      key={idx}
                                      className="suggestion-btn"
                                      onClick={() => {
                                        if (suggestion.action === 'send_message') {
                                          handleSendMessage(suggestion.value);
                                        } else if (suggestion.action === 'append_to_input') {
                                          setQuestion(prev => prev + suggestion.value);
                                        }
                                      }}
                                      title={suggestion.value}
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '6px',
                                        padding: '8px 14px',
                                        borderRadius: '20px',
                                        border: '1px solid #e0e0e0',
                                        background: 'rgba(255, 255, 255, 0.8)',
                                        cursor: 'pointer',
                                        fontSize: '0.9em',
                                        transition: 'all 0.2s',
                                        whiteSpace: 'normal',
                                        textAlign: 'left',
                                        maxWidth: '100%',
                                        lineHeight: '1.4',
                                        height: 'auto',
                                        color: '#333'
                                      }}
                                    >
                                      {suggestion.icon === 'truck' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <path d="M1 3h15v13H1z" />
                                          <path d="M16 8h4l3 3v5h-7V8z" />
                                          <circle cx="5.5" cy="18.5" r="2.5" />
                                          <circle cx="18.5" cy="18.5" r="2.5" />
                                        </svg>
                                      )}
                                      {suggestion.icon === 'code' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <polyline points="16 18 22 12 16 6" />
                                          <polyline points="8 6 2 12 8 18" />
                                        </svg>
                                      )}
                                      {suggestion.icon === 'alert' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <circle cx="12" cy="12" r="10" />
                                          <line x1="12" y1="8" x2="12" y2="12" />
                                          <line x1="12" y1="16" x2="12.01" y2="16" />
                                        </svg>
                                      )}
                                      {suggestion.icon === 'settings' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <circle cx="12" cy="12" r="3" />
                                          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
                                        </svg>
                                      )}
                                      {suggestion.icon === 'zap' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
                                        </svg>
                                      )}
                                      {suggestion.icon === 'lightbulb' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <path d="M9 18h6" />
                                          <path d="M10 22h4" />
                                          <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" />
                                        </svg>
                                      )}
                                      {suggestion.icon === 'disc' && (
                                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ minWidth: '14px' }}>
                                          <circle cx="12" cy="12" r="10" />
                                          <circle cx="12" cy="12" r="3" />
                                        </svg>
                                      )}
                                      <span>{suggestion.value}</span>
                                    </button>
                                  ))}
                                </div>
                              </div>
                            )}
                            {/* End Suggestions */}
                            {index === messages.length - 1 && (
                              <>
                                {/* Only show 'cases' div when there are solutions */}
                                {solutions && Object.keys(solutions).length > 0 && (
                                  <div className='cases'>
                                    {Object.keys(solutions).map((caseId) => (
                                      <button key={caseId} className="case-button" onClick={() => selectCase(caseId)}>Case {caseId}</button>
                                    ))}
                                  </div>
                                )}
                                {selectedCase !== '' && <div className="solution">
                                  <Markdown>{formatMessageContent(solutions[selectedCase])}</Markdown>
                                </div>}
                              </>
                            )}
                          </div>
                        </>
                      )}
                      {message.role === 'user' && (
                        <div className="message-container">
                          <div className="user-message">
                            {message.content}
                          </div>
                          {/* <img src={profileImage} alt="profile-img"></img> */}
                        </div>
                      )}
                    </div>
                    {message.role === 'assistant' && index === messages.length - 1 && !message.streaming && (
                      <div className="actions">
                        <Tooltip label={translate("Good response")} className="tooltip">
                          <button className="thums" onClick={() => {
                            setOverlay(<OverlayTwo />)
                            onOpen()
                            setResponseVote("up")
                          }}>
                            {messageFeedback[index] === "up" ? (
                              // Filled thumbs up (after successful API call)
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M7.23781 11V20H5.62781C4.72781 20 4.00781 19.28 4.00781 18.39V12.62C4.00781 11.73 4.73781 11 5.62781 11H7.23781ZM18.4978 9.5H13.7178V6C13.7178 4.9 12.8178 4 11.7278 4H11.6378C11.2378 4 10.8778 4.24 10.7178 4.61L7.98781 11V20H17.1878C17.9178 20 18.5378 19.48 18.6678 18.76L19.9878 11.26C20.1478 10.34 19.4478 9.5 18.5078 9.5H18.4978Z"
                                  fill="#9CA3AF"
                                />
                              </svg>
                            ) : (
                              // Default outline thumbs up
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M7 10v12" />
                                <path d="M15 5.88 14 10h5.83a2 2 0 0 1 1.92 2.56l-2.33 8A2 2 0 0 1 17.5 22H4a2 2 0 0 1-2-2v-8a2 2 0 0 1 2-2h2.76a2 2 0 0 0 1.79-1.11L12 2h0a3.13 3.13 0 0 1 3 3.88Z" />
                              </svg>
                            )}
                          </button>
                        </Tooltip>

                        <Tooltip label={translate("Bad response")} className="tooltip">
                          <button className="thums" onClick={() => {
                            setOverlay(<OverlayTwo />)
                            onOpen()
                            setResponseVote("down")
                          }}>
                            {messageFeedback[index] === "down" ? (
                              // Filled thumbs down (after successful API call)
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  d="M16.7622 13V4H18.3722C19.2722 4 19.9922 4.72 19.9922 5.61V11.38C19.9922 12.27 19.2622 13 18.3722 13H16.7622ZM5.50219 14.5H10.2822V18C10.2822 19.1 11.1822 20 12.2722 20H12.3622C12.7622 20 13.1222 19.76 13.2822 19.39L16.0122 13V4H6.81219C6.08219 4 5.46219 4.52 5.33219 5.24L4.01219 12.74C3.85219 13.66 4.55219 14.5 5.49219 14.5H5.50219Z"
                                  fill="#9CA3AF"
                                />
                              </svg>
                            ) : (
                              // Default outline thumbs down
                              <svg
                                width="20"
                                height="20"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <path d="M17 14V2" />
                                <path d="M9 18.12 10 14H4.17a2 2 0 0 1-1.92-2.56l2.33-8A2 2 0 0 1 6.5 2H20a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.76a2 2 0 0 0-1.79 1.11L12 22h0a3.13 3.13 0 0 1-3-3.88Z" />
                              </svg>
                            )}
                          </button>
                        </Tooltip>
                        <Tooltip label={translate("Save response")} className="tooltip">
                          <button className="thums" onClick={handleDownload}><img src="./save.svg" alt="saveIcon"></img></button>
                        </Tooltip>
                        <Tooltip label={hasCopied ? translate("Copied") : translate("Copy")} className="tooltip">
                          <button className="thums" onClick={handleCopy}>
                            {hasCopied ? (
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <path d="M20 6L9 17l-5-5" />
                              </svg>
                            ) : (
                              <img src="./copy.svg" alt="saveIcon"></img>
                            )}
                          </button>
                        </Tooltip>
                        {(!speechPlay && !speechSpinner) && <Tooltip label={translate("Read aloud")} className="tooltip">
                          <button className="volumeIcon" onClick={fetchAudio} ><img src="./volume.svg" alt="saveIcon"></img></button>
                        </Tooltip>}
                        {speechSpinner && <Tooltip label={translate("loading")} className="tooltip">
                          <button className="volumeIcon" ><img src="./spinner.gif" alt="spinner"></img></button>
                        </Tooltip>}
                        {(speechPlay && !speechSpinner) && <Tooltip label={translate("stop")} className="tooltip">
                          <button className="volumeIcon" onClick={handlePause}><img src="./audio-stop.svg" alt="audio"></img><source src={audioSrc} type="audio/wav" /></button>
                        </Tooltip>}
                        <audio ref={audioRef}>
                          <source src={audioSrc} type="audio/wav" />
                        </audio>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>}
              {/* Thinking status is now shown inside the streaming message bubble */}

              {isLoadingConversation && (
                <div className="central-loader-overlay">
                  <div className="central-loader-content">
                    <div className="central-loader-spinner" />
                    <div className="central-loader-text">
                      {translate("Loading conversation...")}
                    </div>
                  </div>
                </div>
              )}
            </div>
            <div className='footer'>
              <div className="footer-controls">
                <ResponseModeToggle
                  responseMode={responseMode}
                  setResponseMode={setResponseMode}
                  translate={translate}
                />
                <ModelDropDown
                  selectedModel={selectedModel}
                  setSelectedModel={(value) => {
                    setSelectedModel(value);
                    setSelectedYear('');  // Reset year when model changes
                    if (value) {
                      setIsModelAlertOpen(false);
                    }
                  }}
                  translate={translate}
                  langOpt={langOpt}
                />
                <YearDropDown
                  selectedYear={selectedYear}
                  setSelectedYear={(value) => {
                    setSelectedYear(value);
                    if (value) {
                      setIsYearAlertOpen(false);
                    }
                  }}
                  availableYears={yearsByModel[selectedModel] || []}
                  translate={translate}
                  disabled={!selectedModel}
                />
              </div>
              <div className='question'>
                <img className="input-logo" src={fusotransparent} alt="Assistant" />
                <textarea
                  value={question}
                  onChange={handleChange}
                  placeholder={translate("How can I assist you today?")}
                  className="input-question"
                  onKeyDown={handleKeyPress}
                  onBlur={handleBlur}
                />
                <Dictaphone setQuestion={setQuestion} langOpt={langOpt} />
                <button
                  type="button"
                  onClick={() => handleSendMessage()}
                  className={`send-button ${isAwaitingResponse ? 'awaiting-response' : ''}`}
                  disabled={isAwaitingResponse}
                  style={{
                    opacity: isAwaitingResponse ? 0.5 : 1,
                    cursor: isAwaitingResponse ? 'not-allowed' : 'pointer',
                    pointerEvents: isAwaitingResponse ? 'none' : 'auto'
                  }}
                  title={isAwaitingResponse ? translate("Please wait for the current response") : translate("Send message")}
                >
                  <img src={sendIcon} alt="Send" className="send-icon" />
                </button>
              </div>
            </div>
          </main>
        </div>
      </div>
      <ImageModal imageSrc={selectedImage} isOpen={isImageModalOpen} onClose={closeImageModal} hideZoomControls={hideZoomControls} />

      {/* Custom Model Selection Alert Modal */}
      {isModelAlertOpen && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-box">
            {/* <button className="custom-modal-close" onClick={() => setIsModelAlertOpen(false)}>×</button> */}
            <h2 className="feedback-title" style={{ marginTop: '10px', marginBottom: '10px' }}>{translate("Select Model")}</h2>
            <p style={{ color: '#4A5568', fontSize: '16px', marginBottom: '24px' }}>
              {translate("Please select a model from the dropdown to continue.")}
            </p>
            <div className="custom-modal-footer">
              <button className="closeBtnDTC" onClick={() => setIsModelAlertOpen(false)}>
                {translate("Close")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Custom Year Selection Alert Modal */}
      {isYearAlertOpen && (
        <div className="custom-modal-overlay">
          <div className="custom-modal-box">
            <h2 className="feedback-title" style={{ marginTop: '10px', marginBottom: '10px' }}>{translate("Select Year")}</h2>
            <p style={{ color: '#4A5568', fontSize: '16px', marginBottom: '24px' }}>
              {translate("Please select a year from the dropdown to continue.")}
            </p>
            <div className="custom-modal-footer">
              <button className="closeBtnDTC" onClick={() => setIsYearAlertOpen(false)}>
                {translate("Close")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Product Tour - PC Only */}
      {!/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && (
        <ProductTour translate={(text) => {
          const isDebug = process.env.REACT_APP_DEBUG === 'true';

          if (!isDebug) {
            if (!text || !translations[text]) return text;
            return translations[text].translationJp || text;
          }

          return translate(text);
        }} />
      )}
    </>
  );
}

export default App;
